import { useUserContext } from "../../hooks/userContext";
import { isAdminUser } from "../../utils";
import { useEffect } from "react";
import { useNavigate } from "react-router";
import { DashboardHome } from "./dashboard-home";

export const AdminDashboardPage = () => {
  const { user } = useUserContext();
  const navigate = useNavigate();
  const isAdmin = isAdminUser(user);

  useEffect(() => {
    if (!isAdmin) {
      navigate("/");
    }
  }, [isAdmin, navigate]);

  if (!isAdmin) {
    return null;
  }

  return <DashboardHome />;
};

export default AdminDashboardPage;
